import { render, staticRenderFns } from "./static-page.vue?vue&type=template&id=7e86f23d&scoped=true&"
import script from "./static-page.vue?vue&type=script&lang=js&"
export * from "./static-page.vue?vue&type=script&lang=js&"
import style0 from "./static-page.vue?vue&type=style&index=0&id=7e86f23d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e86f23d",
  null
  
)

export default component.exports